// eslint-disable-next-line no-unused-vars
import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import slackLogo from '../slack-logo.png'

const wrapperCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const contentCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`

const logoWrapperCss = css`
  > img {
    width: 48px;
    height: 48px;
  }
`

const infoCss = css`
  flex-grow: 2;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 252px;
  text-align: center;

  > h4 {
    margin-top: 12px;
    margin-bottom: 12px;
  }
`

const Welcome = () => {
  return (
    <div css={wrapperCss}>
      <div css={contentCss}>
        <div css={logoWrapperCss}>
          <img src={slackLogo} alt="" />
        </div>

        <div css={infoCss}>
          <h4>Connect Slack</h4>

          <div>Respond to LiveChat conversations from Slack.</div>
        </div>
      </div>
    </div>
  )
}

export default Welcome
